/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PagesInputs */

const en__field_pages = /** @type {(inputs: _Field_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages`)
};

/**
* | output |
* | --- |
* | "Pages" |
*
* @param {_Field_PagesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_pages = /** @type {((inputs?: _Field_PagesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PagesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_pages(inputs)
});